const {
  showHideFields,
  calculateMonthlyPayment,
  calculateHouseHoldSalary,
  updateCalculationResults,
  numberFormat,
  filterNumber,
  pmt,
  percentage
} = require('./src/mortgage_calculator');
// const mortgage_calculator = require('./src/mortgage_calculator');
const calculate = require('./src/calculator');
const {
  buyerTypes,
  countries,
  propertyTypes,
  mortageCountryScheme,
  mortagePropertyType
} = require('./src/config');
module.exports = {
  calculate,
  showHideFields,
  buyerTypes,
  countries,
  propertyTypes,
  mortageCountryScheme,
  mortagePropertyType,
  calculateMonthlyPayment,
  calculateHouseHoldSalary,
  updateCalculationResults,
  numberFormat,
  filterNumber,
  pmt,
  percentage
};